<script setup lang="ts">
import { useCabinetMain } from '@/entities/Cabinet'
import { watch } from 'vue'
import { VCopy, VIcons, VStatuses } from '@/shared/ui'
import { useObjectHeader } from './../model/model'
import { useRoute } from 'vue-router'
import { useSseConnection } from '@/shared/lib'
import { debounce } from 'lodash'

const store = useCabinetMain()
const { getIconClass, getBreadcrumbs } = useObjectHeader()
const route = useRoute()

const { refetch } = store.loadCabinetMainData()

/**
 * Генерируем событие успешной загрузки данных
 * для использования в родительском компоненте
 */
const emits = defineEmits(['loadData'])

watch(
  () => store.cabinet,
  () => {
    emits('loadData', store.cabinet)
  },
)

/* Устанавливаем SSE соединение */
const { handler } = useSseConnection(debounce(refetch, 1000))

watch(
  () => route.params.object_id,
  () => {
    handler(`/cabinets/${route.params.object_id}/statuses`)
  },
  { immediate: true },
)
</script>

<template>
  <div class="w-object-header" v-if="store.cabinet">
    <div class="w-object-header__info">
      <VBreadcrumbs :items="getBreadcrumbs(store.cabinet)" />

      <div class="w-object-header__title">
        <VIcons type="host" :class="getIconClass(store.cabinet.status)" />
        <VCopy>{{ store.cabinet.name }}</VCopy>
      </div>

      <div class="w-object-header__serial">
        {{ $t('itf.serial_number') }}:
        <VCopy :size="16">{{ store.cabinet.serial_number || $t('itf.not_info') }}</VCopy>
      </div>
    </div>

    <div class="w-object-header__statuses">
      <VStatuses
        :statuses="store.statuses"
        :class="{ status_disabled: store.cabinet.status == 0 }"
      />

      <div class="w-object-header__events">
        {{ $t('itf.last_event') }}:
        {{ store.statusesDate.last || $t('itf.not_info').toLowerCase() }} /
        {{ $t('itf.last_error_event') }}:
        {{ store.statusesDate.error || $t('itf.not_info').toLowerCase() }}
      </div>
    </div>
  </div>
</template>
